module.exports = __webpack_public_path__ + "static/media/sg-lotto-3x.2261cb9b.png";